export default __webpack_public_path__ + "static/media/mugShot.890ccebe.png";